// Excel样式工具类
class ExcelStyles {
  // 设置ExcelJS表格样式的辅助函数
  static setExcelJSStyle(
    worksheet,
    componentType = "default",
    skipHeaderStyle = false,
  ) {
    // 获取工作表名称
    const sheetName = worksheet.name;
    // 项目参数表和敏感性分析表不需要特殊的数字格式
    const isProjectParamsSheet = sheetName === "项目参数表";
    const isSensitivitySheet =
      sheetName === "敏感性分析表" || sheetName === "敏感度系数和临界点分析表";

    // 标题行样式- 主标题
    const titleRow = worksheet.getRow(1);
    if (titleRow) {
      titleRow.font = {
        name: "Microsoft YaHei",
        size: 12, // 修改为20px
        bold: true,
        color: { argb: "FF2C3E50" },
      };
      titleRow.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFF8F9FA" },
      };
      titleRow.alignment = {
        horizontal: "center",
        vertical: "middle",
      };
      titleRow.height = 40;

      // 设置标题行所有单元格边框
      // titleRow.eachCell({ includeEmpty: true }, (cell) => {
      //   cell.border = this.getDefaultBorder();
      // });
    }

    // 表头行样式- 第二行表头
    if (!skipHeaderStyle) {
      const headerRow = worksheet.getRow(2);
      if (headerRow) {
        headerRow.height = 30;

        // 对所有单元格应用表头样式和高亮，无论是否有值
        headerRow.eachCell({ includeEmpty: true }, (cell, colIndex) => {
          // 设置单元格边框
          cell.border = this.getDefaultBorder();
          // 设置文字居中
          cell.alignment = {
            horizontal: "center",
            vertical: "middle",
          };
          // 设置填充样式（高亮）
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFE3F2FD" },
          };
          // 设置字体样式 - 修改�?px
          cell.font = {
            name: "Microsoft YaHei",
            size: 9,
            bold: true,
            color: { argb: "FF34495E" },
          };
        });
      }
    }

    // 设置数据行样式
    const totalRows = worksheet.rowCount;
    for (let rowIndex = 3; rowIndex <= totalRows; rowIndex++) {
      const row = worksheet.getRow(rowIndex);
      if (row) {
        row.height = 22;

        // 对每行的所有单元格设置样式
        row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
          // 设置单元格边框
          cell.border = this.getDefaultBorder();

          // 统一处理数值格式- 项目参数表和敏感性分析表除外
          if (!isProjectParamsSheet && !isSensitivitySheet) {
            if (typeof cell.value === "number") {
              // 使用工具方法获取合适的数字格式
              const format = this.getNumberFormat(cell.value);
              if (format === "0.00%") {
                // 对于百分比数值，转换为百分比格式
                if (Math.abs(cell.value) < 0.00005) {
                  // 更精确的零值判断
                  cell.value = "";
                } else {
                  cell.numFmt = "0.00%";
                }
              } else if (format === "#,##0.00") {
                // 对于普通数值
                if (Math.abs(cell.value) < 0.005) {
                  cell.value = "";
                } else {
                  cell.numFmt = "#,##0.00";
                }
              }
            }
            // 处理字符串形式的百分比
            else if (
              typeof cell.value === "string" &&
              cell.value.includes("%")
            ) {
              const percentMatch = cell.value.match(
                /(-?[\d.]+(?:\.\d+)?)%\s*$/,
              );
              if (percentMatch) {
                const percentValue = parseFloat(percentMatch[1]) / 100; // 转换为小数形式
                if (!isNaN(percentValue)) {
                  if (Math.abs(percentValue) < 0.00005) {
                    cell.value = "";
                  } else {
                    cell.value = percentValue;
                    cell.numFmt = "0.00%";
                  }
                }
              }
            }
          }

          // 设置字体 - 修改为9px
          cell.font = {
            name: "Microsoft YaHei",
            size: 9,
          };

          // 设置对齐方式
          // 如果是第一列（序号列），确保是整数格式且居中
          if (colNumber === 1) {
            // 确保序号是整数格式
            if (typeof cell.value === "number") {
              // 检查是否为整数
              if (Number.isInteger(cell.value)) {
                cell.numFmt = "#"; // 整数格式
              }
            }
            cell.alignment = {
              vertical: "middle",
              horizontal: "center",
            };
          } else if (colNumber === 2) {
            // 第二列（项目名称列）左对齐
            cell.alignment = {
              vertical: "middle",
              horizontal: "left",
            };
          } else if (cell.value === "建设期" || cell.value === "运营期" || cell.value === "建设期/运营期" || (rowIndex >= 3 && worksheet.getRow(rowIndex).getCell(2).value === "建设期/运营期")) {
            // 建设期和运营期文字居中并设置统一背景色
            // 同时检查整行是否是建设期/运营期行（第二列值为"建设期/运营期"）
            cell.alignment = {
              vertical: "middle",
              horizontal: "center",
            };
            // 设置统一的背景色
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "F0F9FF" },
            };
            // 设置字体加粗
            cell.font = {
              name: "Microsoft YaHei",
              size: 9,
              bold: true,
            };
          } else {
            // 其他列（如数值列）右对齐
            cell.alignment = {
              vertical: "middle",
              horizontal: "right",
            };
          }
        });
      }
    }

    return worksheet;
  }

  // 获取数值格式
  static getNumberFormat(value) {
    if (typeof value === "number") {
      // 判断是否为百分比值（在-1到1之间的非零值）
      if (value > -1 && value < 1 && value !== 0) {
        return "0.00%";
      }
      // 数值格式（保留2位小数）
      return "#,##0.00";
    }
    return "General";
  }

  // 获取默认边框样式
  static getDefaultBorder() {
    return {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  }

  // 根据组件类型设置特定样式
  static setComponentSpecificStyle(worksheet, componentType) {
    switch (componentType) {
      case "investment":
        // 投资估算表特定样式
        for (let rowIndex = 3; rowIndex <= worksheet.rowCount; rowIndex++) {
          const row = worksheet.getRow(rowIndex);
          if (row) {
            // 检查是否是主要类别行（如"建设投资", "流动资金", "建设期利息", "总投资"）
            const firstCell = row.getCell(1);
            if (
              firstCell.value &&
              (firstCell.value === "建设投资" ||
                firstCell.value === "流动资金" ||
                firstCell.value === "建设期利息" ||
                firstCell.value === "总投资")
            ) {
              // 加粗主要类别行
              row.eachCell({ includeEmpty: true }, (cell) => {
                if (cell.font) {
                  cell.font.bold = true;
                }
              });

              // 设置特殊背景色
              row.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFF0F0F0" },
              };
            }

            // 对于二级类别（如"其中：工程费用"）
            const cellValue = firstCell.value;
            if (
              cellValue &&
              typeof cellValue === "string" &&
              (cellValue.includes("其中") || cellValue.includes("      "))
            ) {
              row.font = {
                name: "Microsoft YaHei",
                size: 9, // 修改为9px
                bold: false,
              };
            }
          }
        }
        break;

      case "revenue":
        // 营业收入表特定样式
        for (let rowIndex = 3; rowIndex <= worksheet.rowCount; rowIndex++) {
          const row = worksheet.getRow(rowIndex);
          if (row) {
            // 对汇总行（包含"合计""总计"等字样的行）进行特殊处理
            let isTotalRow = false;
            row.eachCell({ includeEmpty: true }, (cell) => {
              if (
                cell.value &&
                typeof cell.value === "string" &&
                (cell.value.includes("合计") ||
                  cell.value.includes("总计") ||
                  cell.value.includes("利润") ||
                  cell.value.includes("税"))
              ) {
                isTotalRow = true;
              }
            });

            if (isTotalRow) {
              row.eachCell({ includeEmpty: true }, (cell) => {
                cell.font = {
                  name: "Microsoft YaHei",
                  size: 9, // 修改为9px
                  bold: true,
                };

                // 设置特殊背景色
                cell.fill = {
                  type: "pattern",
                  pattern: "solid",
                  fgColor: { argb: "FFF0F8FF" },
                };
              });
            }
          }
        }
        break;

      default:
        // 默认样式处理
        break;
    }
  }
}

export default ExcelStyles;

